/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.educator-growth.dates'},
});

const DatesItem = () => (
  <RouteLinkItem
    route="midas/settings/educator-growth/dates"
    title={messages.title}
  />
);

export default DatesItem;
